type TransitionMap = {
  from: string,
  to: string,
  redirectTo: string
}

export const VALID_PAGE_TRANSITION_MAP: TransitionMap[] = [
  {
    from: '/register/signup',
    to: '/register/complete',
    redirectTo: '/'
  }
];
